import { Link, useParams } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
} from '@tanstack/react-query';
import Card from 'components/card';
import Button from 'components/button';
import SimpleTable from 'components/simpleTable';
import Header from 'components/text/header';
import UseApi from 'hooks/useApi';
import { HiArrowLeft } from 'react-icons/hi';
import Loader from 'components/loader';

const queryClient = new QueryClient();

const ContactFormData = () => {
  const { id } = useParams();

  const { getApi, patchApi, deleteApi } = UseApi();

  async function fetchData(id: string) {
    const response = await getApi(`contactUs/${id}`);
    return response.data;
  }

  const { data, isLoading, error } = useQuery({
    queryKey: ['data', id],
    queryFn: () => fetchData(id),
  });

  if (isLoading) return <Loader />;
  if (error) return <Header>An error has occurred: {error.message}</Header>;
  const { email, firstName, lastName, phone, description, metadata } = data;

  const archive = async () => {
    await patchApi(`contactUs/${id}/metadata`, {
      isArchived: true,
      archivedOn: new Date(),
    });
  };
  const remove = async () => {
    await deleteApi(`contactUs/${id}`);
  };
  return (
    <div className="flex flex-col gap-3">
      <Link key={1} to={'/admin/contact-form'}>
        <Button variant="gray" extraClasses="flex items-center gap-2 ">
          <HiArrowLeft />
          Back
        </Button>
      </Link>
      <Card extra="gap-2 p-4">
        <SimpleTable
          data={[
            { key: 'Email', value: email },
            { key: 'Name', value: firstName + ' ' + lastName },
            { key: 'Phone', value: phone },
            { key: 'Description', value: description },
          ]}
        />

        {!metadata?.isArchived && (
          <Button extraClasses="m-auto" onClick={archive} variant="error">
            Archive
          </Button>
        )}
        {/* <Button extraClasses="m-auto" onClick={remove}>
          delete
        </Button> */}
      </Card>
    </div>
  );
};

const ContactFormDetails = (props: {}) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ContactFormData />
    </QueryClientProvider>
  );
};

export default ContactFormDetails;
